import { useSyncExternalStore } from "react"

const MOBILE_BREAKPOINT = 768

let mql: MediaQueryList | null = null

function getMql() {
  if (mql === null && typeof window !== "undefined") {
    mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
  }
  return mql
}

function subscribe(callback: () => void) {
  const m = getMql()
  if (!m) return () => undefined
  m.addEventListener("change", callback)
  return () => m.removeEventListener("change", callback)
}

function getSnapshot() {
  return getMql()?.matches ?? false
}

function getServerSnapshot() {
  return false
}

export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
